import React, { useEffect, useState } from "react";
import { Button } from "Components/atoms/Button";
import { SERPPagination } from "shared/types/serpResult";
import { PaginationContainer } from "./styles";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

interface Props {
  pagination: SERPPagination;
  changePage: (page: number) => void;
}

const PaginationComponent = ({ pagination, changePage }: Props) => {
  const [isMobile, setMobile] = useState(false);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setMobile(breakpoint !== "xxl");
  }, [breakpoint]);

  const renderPages = () => {
    const pageCount = Math.ceil(pagination.total / pagination.maxItemsPerPage);
    const startPage = Math.max(1, pagination.currentPage - 2);
    const endPage = Math.min(pageCount, pagination.currentPage + 2);

    const pages = [];

    for (let index = startPage; index <= endPage; index++) {
      pages.push(
        <React.Fragment key={index}>
          <Button
            onClick={() => changePage(index)}
            label={index.toString()}
            backgroundColor="white"
            color={pagination.currentPage === index ? "lightRed" : "mediumBlue"}
          />
          &nbsp;
        </React.Fragment>,
      );
    }

    return pages;
  };

  return (
    <>
      {pagination && pagination?.total > pagination?.maxItemsPerPage && (
        <PaginationContainer aria-label="Paginação">
          {pagination.currentPage > 1 && (
            <Button
              onClick={() => changePage(pagination.currentPage - 1)}
              key="previous"
              label={isMobile ? "<" : "Anterior"}
              backgroundColor="mediumBlue"
            />
          )}

          {renderPages()}

          {pagination.currentPage > 0 &&
            pagination.currentPage <
              Math.ceil(pagination.total / pagination.maxItemsPerPage) && (
              <Button
                onClick={() => changePage(pagination.currentPage + 1)}
                key="next"
                label={isMobile ? ">" : "Próxima"}
                backgroundColor="mediumBlue"
              />
            )}
        </PaginationContainer>
      )}
    </>
  );
};

export default PaginationComponent;
